import { render, staticRenderFns } from "./WhySupportPage.vue?vue&type=template&id=354cae54&scoped=true"
import script from "./WhySupportPage.vue?vue&type=script&lang=js"
export * from "./WhySupportPage.vue?vue&type=script&lang=js"
import style0 from "./WhySupportPage.vue?vue&type=style&index=0&id=354cae54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354cae54",
  null
  
)

export default component.exports